'use client';

import * as React from 'react';

import type { CityCode } from '@loci/city-editions';

import { DiscoverAccessCard } from '@/components/molecules/DiscoverAccessCard';
import { DiscoverTasteCard } from '@/components/molecules/DiscoverTasteCard';

/**
 * WEB-937 — one head-slot composition for the desktop rail and the ≤980
 * filter sheet. Taste card (signed-in with signal) and access card
 * (anonymous) each return `null` when they do not apply, so only one of
 * them paints. Mounting the same pair in both hosts avoids a second copy
 * of the card markup.
 */
export function DiscoverRailHeadCards({
  cityCode,
  initialTotal,
  initialTotalsScope,
}: {
  readonly cityCode: CityCode;
  readonly initialTotal?: number;
  readonly initialTotalsScope?: string;
}): React.ReactElement {
  return (
    <>
      <DiscoverTasteCard cityCode={cityCode} />
      <DiscoverAccessCard
        cityCode={cityCode}
        initialTotal={initialTotal}
        initialTotalsScope={initialTotalsScope}
      />
    </>
  );
}
